module.exports = __webpack_public_path__ + "media/images/story/top/arrow-1a31fbff65c13c850b5c0dfbd1c4e24b.png";